import React, {useEffect, useState} from "react";
import {makeStyles} from "@material-ui/core/styles";
import Service from "../services/Service";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from '@material-ui/lab/Alert';
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
//import TextField from "@material-ui/core/TextField";
import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import MenuItem from "@material-ui/core/MenuItem";
import InputAdornment from '@material-ui/core/InputAdornment';
import Select from '@material-ui/core/Select';
import DialogActions from "@material-ui/core/DialogActions";
import _ from 'lodash'
import {useDispatch, useSelector} from "react-redux";
import {editTransaction, getPortfolio, getPortfolios, isEmptyProfile} from "../store/actions";
import {currencies,transactionsType} from "../AppConstants";
import {useFormik} from 'formik';
import * as yup from 'yup';
import Asynchronous from "./Asynchronous";
import ruLocale from 'date-fns/locale/ru';

import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DateTimePicker from '@mui/lab/DateTimePicker';


import {store} from "../store/store";
const service = new Service();
const Alert = (props) => {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}
function NumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.floatValue,
                    },
                });
            }}
            thousandSeparator={' '}
            decimalSeparator={ ','}
        />
    );
}
NumberFormatCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};
const validationSchema = yup.object({
    quantity: yup.number()
        .min(0, "Введите количество больше 0")
        .max(999999999999, "Слишком большое значение")
        .required(
            "Введите количество"
        ),
    price: yup.number()
        .min(0, "Введите сумму больше 0")
        .max(999999999999, "Слишком большое значение")
        .required(
            "Введите сумму"
        ),
    dateTime: yup.date()
        .max(new Date(), `Указано будущее время`)
        .required(
            "Пожалуйста, введите дату сделки"
        ),
});


export default function TransactionAddDialog(props) {
    const mobile = props.mobile
    const useStyles = makeStyles({
        btn: {
            marginLeft: "40px",
            marginRight: "40px",
            height: "40px",
            minWidth: "160px",
            textTransform: 'none',
            borderRadius: 12
        },
        mob_btn: {
            height: 40,
            white: 56,
            borderRadius: 12,
            position: 'fixed',
            bottom: 70,
            right: 20

        }
    });
    const classes = useStyles();
    const portfolioList = useSelector(store => store.portfolios?.list);
    const selectedIndex = useSelector(store => store.user.portfolio);

    const [portfolio, setPortfolio] = useState(portfolioList[selectedIndex]?.id || undefined)

    const dispatch = useDispatch();
    const isEmpty = useSelector(store => store.profile?.isEmpty)
    const transaction = useSelector(store => store.transaction.transaction)

    const [open, setOpen] = useState(false);
    const [openAlert, setOpenAlert] = useState(false);

    useEffect(() => {
        setPortfolio(portfolioList[selectedIndex]?.id || undefined)
    }, [portfolioList, selectedIndex]);

    useEffect(() => {
        if (isEmpty) {
            setOpen(true)
        }
    }, [isEmpty])

    //const dispatch = useDispatch()

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        if (isEmpty){
            dispatch(isEmptyProfile(false))
        }
        if (transaction) {
           dispatch(editTransaction(undefined))
        }
    };

    const handleSend = () => {
        service.createPortfolio(
            {
                "name": name,
                "currency": currency
            }
        ).then((result) => {
            console.log(result)
            //dispatch(getPortfolio())
            setOpen(false);
            setCurrency('RUB');
            setName('');
            setOpenAlert(true);
        }).catch(() => {
            alert('Ошибка при добавлении');
        });
    };

    const handleCloseAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };


    const formik = useFormik({
        initialValues:{
            security: '',
            quantity: '',
            price: '',
            dateTime: '',
            currency: 'RUB',
            commission: '',
            commission_currency: 'RUB',
            type: 'INPUT'
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            // alert(JSON.stringify(values, null, 2));
            // return undefined;
            //handleSend()
            if (values.commission==''){
                values.commission=0.0
            }
            values.portfolio = portfolio
            if (transaction){
                service.updateTransaction(values,transaction.id).then((result) => {
                    dispatch(getPortfolio(portfolio));
                }).catch(() => {
                    alert('Ошибка при редактировании');
                });
                //updateTransaction
            }
            else {
                service.createTransaction(values).then((result) => {
                    dispatch(getPortfolio(portfolio));
                }).catch(() => {
                    alert('Ошибка при добавлении');
                });
            }

            handleClose()
        },
    });

    const [name, setName] = useState('')
    const [currency, setCurrency] = useState('RUB');
    // const handleChange = (event) => {
    //     setCurrency(event.target.value);
    // };
    const getChildVal = (value)=>{
        console.log(value)
        formik.setFieldValue('security', value?.id)
        formik.setFieldValue('price', _.round((value?.price), 2))
        if(value){
            formik.setFieldValue('currency', value?.currency)
            formik.setFieldValue('commission_currency', value?.currency)
        }
    }
    useEffect(() => {
        if (transaction) {
            formik.setFieldValue('security', transaction.row.security)
            formik.setFieldValue('quantity',transaction.row.quantity)
            formik.setFieldValue('price',transaction.row.price)
            formik.setFieldValue('dateTime',transaction.row.dateTime)
            formik.setFieldValue('currency',transaction.row.currency)
            formik.setFieldValue('commission',transaction.row.commission)
            formik.setFieldValue('commission_currency',transaction.row.commission_currency)
            formik.setFieldValue('type',transaction.row.type)
            setOpen(true)
        } else{
            formik.setFieldValue('security', '')
            formik.setFieldValue('quantity','')
            formik.setFieldValue('price','')
            formik.setFieldValue('dateTime',new Date())
            formik.setFieldValue('currency','RUB')
            formik.setFieldValue('commission','')
            formik.setFieldValue('commission_currency','RUB')
            formik.setFieldValue('type','INPUT')
        }
    }, [transaction])

    return (
        <>
            {mobile?
                <Button variant="contained"
                        onClick={handleClickOpen} className={classes.mob_btn}>+</Button>
                :<Button variant="contained"
                         onClick={handleClickOpen} className={classes.btn}>
                    Добавить сделку
                </Button>
            }
            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">{transaction ? "Редактировать сделку" :"Добавить сделку"}</DialogTitle>
                <form onSubmit={formik.handleSubmit}>
                    <DialogContent>
                        {transaction ?
                            <TextField
                                    disabled
                                    style={{ marginBottom: 10 }}
                                    placeholder="20"
                                    variant="outlined"
                                    fullWidth
                                    id="security_redonly"
                                    name="security_redonly"
                                    label="Бумага/компания"
                                    value={transaction.row.name}
                                />

                            :
                            <Asynchronous action={getChildVal} />
                        }

                        <TextField
                            style={{ marginBottom: 10 }}
                            fullWidth
                            id="type"
                            variant="outlined"
                            name="type"
                            label="type"
                            select
                            label="Тип операции"
                            value={formik.values.type}
                            onChange={formik.handleChange}
                            fullWidth
                        >
                            {transactionsType.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>
                        <TextField
                            InputLabelProps={{shrink: true}}
                            style={{ marginBottom: 10 }}
                            placeholder="20"
                            variant="outlined"
                            fullWidth
                            id="quantity"
                            name="quantity"
                            label="Количество"
                            autoComplete='off'
                            InputProps={{
                                inputComponent: NumberFormatCustom,
                            }}
                            value={formik.values.quantity}
                            onChange={formik.handleChange}
                            error={formik.touched.quantity && Boolean(formik.errors.quantity)}
                            helperText={formik.touched.quantity && formik.errors.quantity}
                        />
                        <TextField
                            style={{ marginBottom: 10 }}
                            placeholder="50"
                            variant="outlined"
                            fullWidth
                            label="Цена"
                            id="price"
                            name="price"
                            autoComplete='off'
                            value={formik.values.price}
                            onChange={formik.handleChange}
                            error={formik.touched.price && Boolean(formik.errors.price)}
                            helperText={formik.touched.price && formik.errors.price}
                            InputProps={{
                                inputComponent: NumberFormatCustom,
                                startAdornment: <InputAdornment position="start">
                                    <Select
                                        id="currency"
                                        name="currency"
                                        value={formik.values.currency}
                                        onChange={formik.handleChange}
                                    >
                                        {currencies.map((option) => (
                                            <MenuItem key={option.id} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </InputAdornment>
                            }}
                        />
                        {/*<TextField*/}
                        {/*    style={{ marginBottom: 10 }}*/}
                        {/*    variant="outlined"*/}
                        {/*    fullWidth*/}
                        {/*    id="dateTime"*/}
                        {/*    name="dateTime"*/}
                        {/*    InputLabelProps={{shrink: true}}*/}
                        {/*    label="Дата и время"*/}
                        {/*    type="datetime-local"*/}
                        {/*    value={formik.values.dateTime}*/}
                        {/*    onChange={formik.handleChange}*/}
                        {/*    error={formik.touched.dateTime && Boolean(formik.errors.dateTime)}*/}
                        {/*    helperText={formik.touched.dateTime && formik.errors.dateTime}*/}
                        {/*/>*/}
                        <LocalizationProvider dateAdapter={AdapterDateFns} locale={ruLocale}>
                            <DateTimePicker
                                value={formik.values.dateTime}

                                onChange={(newValue) => {
                                    formik.setFieldValue('dateTime',newValue)
                                        }}
                                maxDateTime={new Date()}
                                mask="__.__.____ __:__"
                                label="Дата и время"
                                renderInput={(params) =>
                                    <TextField
                                        variant="outlined"
                                        //type="datetime-local"
                                        name="dateTime"
                                        label="Дата и время"
                                        fullWidth
                                        InputLabelProps={{shrink: true}}
                                        style={{ marginBottom: 10 }}
                                        error={formik.touched.dateTime && Boolean(formik.errors.dateTime)}
                                        helperText={formik.touched.dateTime && formik.errors.dateTime}
                                        {...params}
                                    />}
                            />
                        </LocalizationProvider>
                        <TextField
                            variant="outlined"
                            fullWidth
                            label="Комиссия"
                            placeholder="0"
                            id="commission"
                            autoComplete='off'
                            name="commission"
                            value={formik.values.commission}
                            onChange={formik.handleChange}
                            error={formik.touched.commission && Boolean(formik.errors.commission)}
                            helperText={formik.touched.commission && formik.errors.commission}
                            InputProps={{
                                inputComponent: NumberFormatCustom,
                                startAdornment: <InputAdornment position="start">
                                    <Select
                                        id="commission_currency"
                                        name="commission_currency"
                                        value={formik.values.commission_currency}
                                        onChange={formik.handleChange}
                                    >
                                        {currencies.map((option) => (
                                            <MenuItem key={option.id} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </InputAdornment>,
                            }}
                        />

                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} color="primary">
                            Отмена
                        </Button>
                        <Button color="primary" type="submit">
                            Ок
                        </Button>
                    </DialogActions>
                </form>

            </Dialog>
            <Snackbar open={openAlert} autoHideDuration={2000} onClose={handleCloseAlert}>
                <Alert onClose={handleCloseAlert} severity="success">
                    Сделка добавлена!
                </Alert>
            </Snackbar>
        </>
    );
}